import Container from '@/components/Container';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import SupportersCenter from '@/pages/about-us/supporters-club/SupportersCenter';
import SupportersClub from '@/pages/about-us/supporters-club/SupportersClub';
import { PageProps } from 'gatsby';
import React, { FC, useEffect, useRef, useState, useMemo } from 'react';
import styled from 'styled-components';

const honorTab = [
  {
    idx: 0,
    title: `지역후원센터`,
  },
  {
    idx: 1,
    title: `지역후원회`,
  },
];
const SectionTab = styled.div`
  height: 80px;
  border-bottom: 3px solid #c6c6c6;
  ${breakpoint(`mobile`)} {
    ${Container} {
      padding: 0;
    }
  }
`;

const TabButton = styled.li<{ active: boolean }>`
  cursor: pointer;
  width: 50%;
  height: 80px;
  line-height: 1.25;
  display: inline-flex;
  align-items: center;
  border-bottom: 3px solid #c6c6c6;
  border-color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  margin: 0;
  &:hover {
    border-color: #1cabe2;
    color: #1cabe2;
  }
  span {
    display: block;
    width: 100%;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    em {
      font-weight: 700;
    }
  }
  ${breakpoint(`mobile`)} {
    span {
      font-size: 16px;
      em {
        display: block;
      }
    }
  }
`;

const SponsorshipClone: FC<PageProps> = ({ location }) => {
  const targetRef = useRef<HTMLLIElement | null>(null);
  const [activeTab, setActiveTab] = useState(0);

  const tab: { [key: number]: ReactElement } = {
    0: <SupportersCenter location={location} />,
    1: <SupportersClub location={location} />,
  };

  return (
    <LayoutWithTitle
      location={{
        ...location,
      }}
      title="지역후원회"
      description="for every child, UNICEF Supporters Club"
    >
      {/* <SupportersClub {...pageProps} /> */}
      <SectionTab>
        <Container>
          <ul className="flex">
            {honorTab.map(({ title, idx }) => (
              <TabButton
                ref={(ref) => {
                  if (activeTab === idx) {
                    targetRef.current = ref;
                  }
                }}
                active={activeTab === idx}
                key={idx}
                onClick={() => setActiveTab(idx)}
              >
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </TabButton>
            ))}
          </ul>
        </Container>
      </SectionTab>
      {tab[activeTab]}
    </LayoutWithTitle>
  );
};

export default SponsorshipClone;
